import { render, staticRenderFns } from "./ChainNearby.vue?vue&type=template&id=4932f2c8&scoped=true"
import script from "./ChainNearby.vue?vue&type=script&lang=js"
export * from "./ChainNearby.vue?vue&type=script&lang=js"
import style0 from "./ChainNearby.vue?vue&type=style&index=0&id=4932f2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932f2c8",
  null
  
)

export default component.exports